const template = `
	<div class="text-field" :class="classMap">
		<div v-if="error" class="error-msg">{{ error }}</div>
		<div v-if="prependIcon" class="prepend-icon" @click="focus">
			<i :class="'fa fa-fw fa-' + prependIcon"></i>
		</div>
		<input
			ref="tf"
			:type="inputType"
			:value="value"
			:placeholder="placeholder"
			:name="name"
			:disabled="disabled"
			:readonly="readonly ? 'readonly' : null"
			@keyup.enter="$emit('enter')"
			@focus="onFocus"
			@blur="onBlur"
			@input="onInput($event)"
			@change="onChange($event)"
		/>
		<i v-if="error" class="error-icon fa fa-exclamation-triangle"></i>
		<i v-if="loading" class="loading-icon fa fa-spinner spin-fast"></i>
	</div>
`;

export default {
	template,
	props: [
		'value',
		'type',
		'prepend-icon',
		'placeholder',
		'name',
		'disabled',
		'readonly',
		'error',
		'loading',
		'autofocus',
		'lazy'
	],
	data() {
		return {
			focused: false
		}
	},
	computed: {
		inputType() {
			return this.type || 'text';
		},
		classMap() {
			return {
				'text-field-left-icon': this.prependIcon,
				'text-field-focused': this.focused,
				'text-field-disabled': this.disabled,
				'text-field-error': this.error,
				'text-field-loading': this.loading
			};
		}
	},
	methods: {
		onFocus(e) {
			this.focused = true;
			this.$emit('focus', e);
		},
		onBlur(e) {
			this.focused = false;
			this.$emit('blur', e);
		},
		onInput(e) {
			if (!this.lazy) {
				this.$emit('input', e.target.value);
			}
		},
		onChange(e) {
			if (this.lazy) {
				this.$emit('input', e.target.value);
			}
			this.$emit('change', e);
		},
		focus() {
			this.$refs.tf.focus();
		}
	},
	mounted() {
		if (this.autofocus) {
			this.focus();
		}
	}
}